import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {area, mk} from '@mintdata/mint-kit/api/log/mk';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata-wsp/common/components/icon/Icon.less');
const cx = classnames.bind(styles);

export enum MDIconSize
{
    xlarge = 'xlarge',          // 40
    large = 'large',            // 32
    medium = 'medium',          // 24
    medium20 = 'medium20',
    medium18 = 'medium18',
    medium16 = 'medium16',
    medium14 = 'medium14',
    small = 'small',            // 12
    xsmall = 'xsmall',          // 10
    xlarge_64 = 'xlarge_64',
    xlarge_80 = 'xlarge_80',
    x2small = 'x2small'         // 6
}

export interface IIconProps
{
    name:string;
    className?:string;
    isBlock?:boolean;
    size?:MDIconSize;
    intent?:MDIntent;
    onClick?:React.MouseEventHandler<any>;
    onMouseDown?:React.MouseEventHandler<any>;
}

export class MDIcon extends React.Component<IIconProps, any>
{
    render()
    {
        const {
            name,
            className,
            isBlock,
            size = MDIconSize.medium,
            intent = MDIntent.Default,
            onClick = null,
            onMouseDown = null
        } = this.props;

        try
        {
            const Svg = require(`@mintdata-wsp/common/components/icon/icons/${name}`).default;

            return <Svg onClick={onClick}
                        onMouseDown={onMouseDown}
                        className={cx(styles.baseIcon,
                            intent,
                            className,
                            {isBlock},
                            size)
                        } />;
        }
        catch( error )
        {
            mk.error(area.Icon, 'Could not find icon with name:', name);
            return null;
        }
    }
}
